// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"222":"7ffe1e05","269":"8b87ab61"}[chunkId] + ".chunk.css";
};